import BaseDialog from "@/components/BaseDialog";
// 添加sheet
export function addSheetDialog({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('./addSheetDialog.vue'),
    options: {
      width: '400px',
      title: 'sheet name'
    },
    props,
    cbs
  })
}
// 指定sheet
export function selectSheetDialog({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('./selectSheetDialog.vue'),
    options: {
      width: '510px',
      title: 'Specific sheet'
    },
    props,
    cbs
  })
}





// selectModal
export function selectModal({ options={},props, cbs }) {
    let vmOptions = {
        width: '350px',
    };
    return new BaseDialog({
        component: ()=>import('./selectModal.vue'),
        options: Object.assign({},vmOptions,options),
        props,
        cbs
    })
}
